import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background: var(--carbon-gradient);
  color: var(--white);
  padding: var(--space-8) 0;
  margin-top: var(--space-20);
  border-top: 3px solid var(--racing-red);
`;

const FooterContent = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 var(--space-6);
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: var(--space-6);
    text-align: center;
  }
`;

const Copyright = styled.p`
  color: var(--chrome-silver);
  font-size: var(--text-sm);
  margin: 0;
`;

const LegalNav = styled.nav`
  display: flex;
  gap: var(--space-6);
  
  @media (max-width: 640px) {
    justify-content: center;
    gap: var(--space-4);
  }
`;

const LegalLink = styled(Link)`
  color: var(--chrome-silver);
  text-decoration: none;
  font-size: var(--text-sm);
  font-weight: var(--font-medium);
  transition: color var(--transition-fast);
  
  &:hover {
    color: var(--racing-red);
    text-decoration: none;
  }
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-3);
  margin-bottom: var(--space-4);
`;

const LogoIcon = styled.div`
  width: 35px;
  height: 35px;
  background: var(--racing-gradient);
  border-radius: var(--radius-lg);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--text-base);
  font-weight: var(--font-black);
  color: var(--white);
  box-shadow: var(--shadow-racing);
`;

const LogoText = styled.span`
  font-family: 'Rajdhani', sans-serif;
  font-size: var(--text-xl);
  font-weight: var(--font-black);
  background: linear-gradient(135deg, var(--white) 0%, var(--racing-red) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <FooterContent>
        <Logo>
          <LogoIcon>🏁</LogoIcon>
          <LogoText>CarBuzz.fit</LogoText>
        </Logo>
        
        <Copyright>
          © {currentYear} CarBuzz.fit. All rights reserved.
        </Copyright>
        
        <LegalNav>
          <LegalLink to="/about">About</LegalLink>
          <LegalLink to="/privacy">Privacy</LegalLink>
          <LegalLink to="/terms">Terms</LegalLink>
        </LegalNav>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;
